import {useEffect, useState} from 'react';
import useLocalStorage from './useLocalStorage';
import useAccountFilterMigration from '#app/hooks/useAccountFilterMigration';

const useTransactionFilters = (prefix = 'transaction') => {
    const [filterShow, setFilterShow] = useState(false);

    // Фильтры с localStorage и префиксом
    const [filterDateFrom, setFilterDateFrom] = useLocalStorage(
        `${prefix}_filter_date_from`,
        null
    );
    const [filterDateTo, setFilterDateTo] = useLocalStorage(
        `${prefix}_filter_date_to`,
        null
    );
    const [filterSumFrom, setFilterSumFrom] = useLocalStorage(
        `${prefix}_filter_sum_from`,
        ''
    );
    const [filterSumTo, setFilterSumTo] = useLocalStorage(
        `${prefix}_filter_sum_to`,
        ''
    );

    const [filterCategoryItems, setFilterCategoryItems] = useLocalStorage(
        `${prefix}_filter_categories`,
        []
    );
    const [filterSubcategoryItems, setFilterSubcategoryItems] = useLocalStorage(
        `${prefix}_filter_subcategories`,
        []
    );
    const [filterTagItems, setFilterTagItems] = useLocalStorage(
        `${prefix}_filter_tags`,
        []
    );
    const [showFilterDesc, setShowFilterDesc] = useState(false);
    const [filterDesc, setFilterDesc] = useLocalStorage(
        `${prefix}_filter_desc`,
        ''
    );
    // Храним только массив ID счетов, а не объекты с label
    const [filterAccountIds, setFilterAccountIds] = useLocalStorage(
        `${prefix}_filter_account_ids`,
        []
    );

    // Миграция: если есть старые данные с объектами, конвертируем в массив ID
    useAccountFilterMigration(
        `${prefix}_filter_accounts`,
        `${prefix}_filter_account_ids`,
        filterAccountIds,
        setFilterAccountIds
    );

    const clearFilter = () => {
        setFilterDateFrom(null);
        setFilterDateTo(null);
        setFilterSumFrom('');
        setFilterSumTo('');
        setFilterCategoryItems([]);
        setFilterSubcategoryItems([]);
        setFilterTagItems([]);
        setFilterAccountIds([]);
        setShowFilterDesc(false);
        setFilterDesc('');
    };

    // Автоматически открываем фильтр при первой загрузке, если есть активные фильтры
    // Фильтры НЕ должны закрываться автоматически при сбросе
    useEffect(() => {
        const hasActiveFilters =
            filterDateFrom !== null ||
            filterDateTo !== null ||
            filterSumFrom !== '' ||
            filterSumTo !== '' ||
            filterCategoryItems.length > 0 ||
            filterSubcategoryItems.length > 0 ||
            filterTagItems.length > 0 ||
            filterAccountIds.length > 0 ||
            filterDesc !== '';

        // Если есть активные фильтры - показываем (только при первой загрузке)
        if (hasActiveFilters) {
            setFilterShow(true);
        }
    }, []); // Выполняем только один раз при монтировании

    return {
        filterShow,
        setFilterShow,

        filterDateFrom,
        setFilterDateFrom,
        filterDateTo,
        setFilterDateTo,
        filterSumFrom,
        setFilterSumFrom,
        filterSumTo,
        setFilterSumTo,

        filterCategoryItems,
        setFilterCategoryItems,
        filterSubcategoryItems,
        setFilterSubcategoryItems,
        filterTagItems,
        setFilterTagItems,

        showFilterDesc,
        setShowFilterDesc,
        filterDesc,
        setFilterDesc,

        filterAccountIds,
        setFilterAccountIds,

        clearFilter,
    };
};

export default useTransactionFilters;